import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useLanguageContext } from "../../Context/LanguageContext";
import { AiOutlineDelete } from "react-icons/ai";
import PerformanceConstants from "../../Constants/PerformanceAnalysisConstants";
import performanceStore from "../../Stores/PerformanceAnalysisStore";
import PerformanceAnalysisActions from "../../Actions/PerformanceAnalysisActions";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import ConfirmationPopUp from "../MessageBox/ConfirmationPopUp";

function PerformanceAnalysis() {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [filtPerLog, setFiltPerLog] = useState([]);
  const [controllerName, setControllerName] = useState("");
  const [methodName, setMethodName] = useState("");
  const [duration, setDuration] = useState("");
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const perviousSearchRef = useRef("");
  const [showTable, setShowTable] = useState(false);
  const [showDelButton, setShowDelButton] = useState(true);
  /**-------------------------------------------------------------------Get Performance Result Start---------------------------------------------------- */

  function getPerLogOnDel(filterItem) {
    setGlobalSpinner(true);
    PerformanceAnalysisActions.getfilteredPerAnalysLogs(filterItem);
  }

  useEffect(() => {
    function getFilteredPerformanceSuccess() {
      var res = performanceStore.getFilteredLogResult();
      if (res.length > 0) {
        setFiltPerLog(res);
        setShowTable(true);
        setShowDelButton(false);
      } else {
        setFiltPerLog([]);
        setShowTable(true);
        setShowDelButton(true);
      }
      setGlobalSpinner(false);
    }

    function getFilteredPerformanceFailure() {
      var res = performanceStore.getFilteredLogResult();
      toast.error(res);
      setGlobalSpinner(false);
      setShowDelButton(true);
    }

    performanceStore.addChangeListener(
      PerformanceConstants.GET_FILTER_PERFORMANCE_LOG_SUCCESS,
      getFilteredPerformanceSuccess,
    );

    performanceStore.addChangeListener(
      PerformanceConstants.GET_FILTER_PERFORMANCE_LOG_FAILURE,
      getFilteredPerformanceFailure,
    );
    return () => {
      performanceStore.removeChangeListener(
        PerformanceConstants.GET_FILTER_PERFORMANCE_LOG_SUCCESS,
        getFilteredPerformanceSuccess,
      );

      performanceStore.removeChangeListener(
        PerformanceConstants.GET_FILTER_PERFORMANCE_LOG_FAILURE,
        getFilteredPerformanceFailure,
      );
    };
  }, []);

  function handlePerformanceSearch(e) {
    e.preventDefault();
    setGlobalSpinner(true);
    const filteredObj = {
      ControllerName: controllerName,
      MethodName: methodName,
      Duration: duration,
    };
    perviousSearchRef.current = filteredObj;
    PerformanceAnalysisActions.getfilteredPerAnalysLogs(filteredObj);
  }
  /**-------------------------------------------------------------------Get Performance Result End---------------------------------------------------- */

  /**-------------------------------------------------------------------Delete Single Performance  Start---------------------------------------------------- */

  useEffect(() => {
    function deleteLogSuccess() {
      toast.success(localization.logDeleted);
      getPerLogOnDel(perviousSearchRef.current);
    }
    function deleteLogFailure() {
      const res = performanceStore.getdeleteLogResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    performanceStore.addChangeListener(
      PerformanceConstants.DEL_PERFORMANCE_LOG_SUCCESS,
      deleteLogSuccess,
    );

    performanceStore.addChangeListener(
      PerformanceConstants.DEL_PERFORMANCE_LOG_FAILURE,
      deleteLogFailure,
    );

    return () => {
      performanceStore.removeChangeListener(
        PerformanceConstants.DEL_PERFORMANCE_LOG_SUCCESS,
        deleteLogSuccess,
      );

      performanceStore.removeChangeListener(
        PerformanceConstants.DEL_PERFORMANCE_LOG_FAILURE,
        deleteLogFailure,
      );
    };
  }, []);

  function RenderDeleteButton(props) {
    const id = props.id;
    return (
      <AiOutlineDelete
        className="ml-0 cursorPoint svgIcon"
        title={localization.delete}
        size={20}
        onClick={() => {
          deletePerLog(id);
        }}
      />
    );
  }

  const deletePerLog = (id) => {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.areYouSureYouWantToLog);
    setCallbackData({
      ID: id,
    });
    setEventType("DELETE_PERFORMANCE_LOG");
  };

  /**-------------------------------------------------------------------Delete Single Performance  End---------------------------------------------------- */

  /**-------------------------------------------------------------------Delete Multiple Performance  Start---------------------------------------------------- */

  useEffect(() => {
    function deleteMulExcSuccess() {
      toast.success(localization.logDeleted);
      getPerLogOnDel(perviousSearchRef.current);
    }
    function deleteMulExcFailure() {
      const res = performanceStore.getMuldeleteLogResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    performanceStore.addChangeListener(
      PerformanceConstants.DEL_MUL_PERFORMANCE_LOG_SUCCESS,
      deleteMulExcSuccess,
    );

    performanceStore.addChangeListener(
      PerformanceConstants.DEL_MUL_PERFORMANCE_LOG_FAILURE,
      deleteMulExcFailure,
    );

    return () => {
      performanceStore.removeChangeListener(
        PerformanceConstants.DEL_MUL_PERFORMANCE_LOG_SUCCESS,
        deleteMulExcSuccess,
      );

      performanceStore.removeChangeListener(
        PerformanceConstants.DEL_MUL_PERFORMANCE_LOG_FAILURE,
        deleteMulExcFailure,
      );
    };
  }, []);

  const handleDelMultipleExc = () => {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.areYouSureYouWantToLog);
    setCallbackData({
      serachItem: perviousSearchRef.current,
    });
    setEventType("DELETE_MUL_EXCEPTION");
  };
  /**-------------------------------------------------------------------Delete Multiple Performance  End---------------------------------------------------- */

  /**-------------------------------------------------------------------Delete Confirmation Start---------------------------------------------------- */

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_PERFORMANCE_LOG":
          setGlobalSpinner(true);
          const res = PerformanceAnalysisActions.deletePerfLog(data.ID);
          closePopUpCallback();
          break;
        case "DELETE_MUL_EXCEPTION":
          setGlobalSpinner(true);
          const result =
            PerformanceAnalysisActions.deleteMultiplePerformanceLog(
              data.serachItem,
            );
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };
  /**-------------------------------------------------------------------Delete Confirmation End---------------------------------------------------- */

  return (
    <>
      <div className="w-100 h-100">
        <div className="container-fluid">
          <form
            id="searchPanel"
            name="searchPanel"
            onSubmit={handlePerformanceSearch}
          >
            <div className="row ml-3">
              <div className="col-3">
                <div className="form-group">
                  <label htmlFor="controller" className="mr-3">
                    {localization.controller}
                  </label>
                  <input
                    type="text"
                    id="controller"
                    name="controller"
                    className="form-control"
                    value={controllerName}
                    onChange={(e) => {
                      setControllerName(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="form-group">
                  <label htmlFor="method" className="mr-3">
                    {localization.method}
                  </label>
                  <input
                    type="text"
                    id="method"
                    name="method"
                    className="form-control"
                    value={methodName}
                    onChange={(e) => {
                      setMethodName(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="form-group">
                  <label htmlFor="duration" className="mr-3">
                    {`${localization.duration} (${localization.milliSecond})`}
                  </label>
                  <input
                    type="number"
                    id="duration"
                    name="duration"
                    className="form-control"
                    value={duration}
                    onChange={(e) => {
                      setDuration(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col mt-5 d-flex">
                <div className="form-group  align-items-center">
                  <button type="submit" className="btn btn-primary">
                    {localization.search}
                  </button>
                </div>
                <div className="form-group  align-items-center ml-3">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      setMethodName("");
                      setControllerName("");
                      setDuration("");
                      perviousSearchRef.current = "";
                    }}
                  >
                    {localization.reset}
                  </button>
                </div>
                <div className="form-group  align-items-center ml-3">
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={showDelButton}
                    onClick={() => {
                      handleDelMultipleExc();
                    }}
                  >
                    {localization.delete}
                  </button>
                </div>
              </div>
            </div>
          </form>
          {showTable && (
            <div className="row">
              <div className="col pl-0 ">
                <div className="table-responsive px-3 perTabHeig">
                  <table className="table align-middle mb-0 table-striped table-hover table-sticky">
                    <thead className="bg-light">
                      <tr>
                        <th>{localization.srNo}</th>
                        <th>{localization.id}</th>
                        <th>{localization.users}</th>
                        <th>{localization.controller}</th>
                        <th>{localization.method}</th>
                        <th>{`${localization.duration} (${localization.milliSecond})`}</th>
                        <th>{localization.executedOn}</th>
                        <th>{localization.action}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filtPerLog.length > 0 ? (
                        <>
                          {filtPerLog.map((item, i) => {
                            return (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{item.id}</td>
                                <td>{item.user}</td>
                                <td>{item.controller}</td>
                                <td>{item.method}</td>
                                <td>{item.duration}</td>
                                <td>{item.executedOn}</td>
                                <td>
                                  <RenderDeleteButton id={item.id} />
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      ) : (
                        <>
                          <tr>
                            <td className="text-center" colSpan={100}>
                              <p>{localization.noRecordFound}</p>
                            </td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
        <ConfirmationPopUp
          isOpen={confirmationPopUpOpen}
          okCancelCallback={confirmationOkCancelCallback}
          close={closePopUpCallback}
          title=""
          msg={confirmationPopUpMsg}
          eventType={eventType}
          callbackData={callbackData}
        />
      </div>
    </>
  );
}
export default PerformanceAnalysis;
